import styled, { css } from 'styled-components';

export const Link = styled.a(
  ({ theme }) => css`
    color: ${theme.text.link};

    &:visited {
      color: ${theme.text.linkVisited};
    }
  `
);
